// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"left-content_wrapper__kskdD","firstTitle":"left-content_firstTitle__2CWie","secondTitle":"left-content_secondTitle__1RjzS"};